import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useForm, useFieldArray } from "react-hook-form";

import Form from "/src/components/form/Form";
import IconButton from "/src/components/UI/Button/IconButton/IconButton"
import "./PhoneBlock.css"
const PhoneBlock = (( {data, onClick , index }) => {

    const isAvailable = data.channel_id != null;
    return (
        <>
            <div className="phone-block">
                <div className="container_phone_info">
                    <span className={"flag-icon flag-icon-"+data.country?.alpha_code_2.toLowerCase()}/>
                    <span className="number_phone"> {data.numbers}</span>
                </div>
                <div>
                    <IconButton id={data.id + "button"} className={"main-iconButton modalButtons-input" + (isAvailable ? " checked" : "")}  icon={isAvailable ? "fas fa-check-circle" : "fas fa-plus-circle"} onClick={(e) => onClick != null? onClick(data, index) : ""}/>
                </div>
            </div>
        </>
    )
});

export default PhoneBlock;